import { Mail, Phone, Instagram, ArrowUpRight } from "lucide-react";

// Priya's contact details — the source of truth for the site. Update here.
const CONTACTS = [
  {
    key: "email",
    label: "Email",
    value: "hello@refinewithpriya.com",
    href: "mailto:hello@refinewithpriya.com",
    icon: Mail,
  },
  {
    key: "phone",
    label: "Phone",
    value: "+91 72009 11132",
    href: "tel:+917200911132",
    icon: Phone,
  },
  {
    key: "instagram",
    label: "Instagram",
    value: "@refinewithpriya",
    href: "https://instagram.com/refinewithpriya",
    icon: Instagram,
    external: true,
  },
];

export default function Contact() {
  return (
    <div data-testid="page-contact">
      <section className="container-refined pt-16 md:pt-24 pb-16">
        <div className="grid gap-12 md:grid-cols-[1.1fr_1fr] items-start">
          {/* Left: heading + intro (page heading unchanged per brief) */}
          <div className="animate-fade-up">
            <span className="eyebrow">Say hello</span>
            <h1 className="font-serif mt-4 text-4xl sm:text-5xl lg:text-6xl leading-[1.05]">
              Come as you are. Even the tired, uncertain, unsure-what-to-say parts.
            </h1>
            <p className="font-script text-4xl mt-3">Where You&rsquo;re Heard.</p>
            <p className="mt-6 max-w-xl text-base md:text-lg leading-relaxed" style={{ color: "#2A2621" }}>
              No forms, no pressure. Reach out whenever you&rsquo;re ready.
            </p>
          </div>

          {/* Right: elegant contact card */}
          <aside
            data-testid="contact-card"
            className="rounded-3xl border p-8 md:p-10"
            style={{
              background: "#FAF6EC",
              borderColor: "rgba(201,168,76,0.55)",
              boxShadow: "0 40px 80px -40px rgba(27,67,50,0.4)",
            }}
          >
            <span className="eyebrow">Direct lines</span>
            <h2 className="font-serif mt-3 text-3xl md:text-4xl leading-tight" style={{ color: "#1B4332" }}>
              Say the word.
            </h2>
            <p className="mt-3 text-[15px] leading-relaxed" style={{ color: "#2A2621" }}>
              Whichever door feels easiest &mdash; every one of them lands with Priya personally.
            </p>

            <ul className="mt-8 space-y-3">
              {CONTACTS.map((c) => (
                <li key={c.key}>
                  <ContactLink item={c} />
                </li>
              ))}
            </ul>

            <p className="mt-8 text-xs" style={{ color: "#6E6759" }}>
              Held gently. Never shared. Never used for cold outreach.
            </p>
          </aside>
        </div>
      </section>
    </div>
  );
}

function ContactLink({ item }) {
  const Icon = item.icon;
  const external = !!item.external;
  return (
    <a
      href={item.href}
      target={external ? "_blank" : undefined}
      rel={external ? "noreferrer noopener" : undefined}
      data-testid={`contact-link-${item.key}`}
      className="group flex items-center gap-4 rounded-2xl border p-4 transition-all hover:-translate-y-0.5"
      style={{ background: "#fff", borderColor: "rgba(27,67,50,0.12)" }}
    >
      <span
        className="inline-flex h-11 w-11 items-center justify-center rounded-full border shrink-0 transition-colors group-hover:bg-[#1B4332] group-hover:text-[#C9A84C]"
        style={{ borderColor: "#C9A84C", color: "#1B4332", background: "#FAF6EC" }}
      >
        <Icon size={18} />
      </span>
      <div className="min-w-0 flex-1">
        <div className="text-[11px] tracking-[0.24em] uppercase" style={{ color: "#6E6759" }}>
          {item.label}
        </div>
        <div className="font-serif text-lg md:text-xl truncate" style={{ color: "#1B4332" }}>
          {item.value}
        </div>
      </div>
      <ArrowUpRight
        size={18}
        className="opacity-40 group-hover:opacity-100 transition-opacity shrink-0"
        style={{ color: "#1B4332" }}
      />
    </a>
  );
}
